<div class="program-header">
  <div class="program-header__row">
    @if (!hideTitle) {
      <h1 class="program-header__title headline5">{{ displayTitle }}</h1>
    }

    <div class="program-header__actions">
      @if (showActions && availableLanguages?.length > 1) {
        <ptl-button
          type="smoke"
          [size]="'m'"
          [matMenuTriggerFor]="languageMenu"
          [icon]="LucideLanguages"
          [ariaLabel]="'translations.global.ariaLabels.icons.language' | transloco"
        ></ptl-button>
      }

      <mat-menu #languageMenu="matMenu">
        @for (language of availableLanguages; track language.code) {
          <button
            mat-menu-item
            class="language-menu-item"
            [class.is_active]="language.code === selectedLanguageCode"
            [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
            (click)="languageSelect(language.code)"
            [value]="language.code"
          >
            {{ language.code.toUpperCase() }}
          </button>
        }
      </mat-menu>

      @if (canEdit) {
        <ptl-button
          class="edit-btn"
          [size]="'s'"
          type="smoke"
          [icon]="LucidePencil"
          [text]="'translations.programs.edit.editContent' | transloco"
          (clicked)="editClicked.emit()"
        ></ptl-button>
      }

      @if (showActions) {
        <ptl-button
          type="smoke"
          [size]="'s'"
          [icon]="LucideShare2"
          [ariaLabel]="'translations.global.ariaLabels.icons.share' | transloco"
          (clicked)="shareProgram()"
        ></ptl-button>

        @if (!isCard) {
          <ptl-button
            type="smoke"
            [size]="'s'"
            [icon]="$any(program)?.favorite ? LucideBookmark : LucideBookmarkCheck"
            [ariaLabel]="'translations.global.ariaLabels.icons.save' | transloco"
            (clicked)="saveItem()"
          ></ptl-button>
        }

        <ptl-button
          type="smoke"
          [size]="'s'"
          [icon]="LucideDownload"
          [ariaLabel]="'translations.global.ariaLabels.icons.download' | transloco"
          (clicked)="downloadReport()"
        >
          @if (downloadInProgress) {
            <mat-spinner [diameter]="16"></mat-spinner>
          }
        </ptl-button>
      }
    </div>
  </div>

  @if (report) {
    <div class="card-view__report-container">
      <ptl-playlist-report
        #playlistReportComponent
        [report]="report"
        (pdfDownloaded)="onReportDownloaded()"
        (pdfError)="onReportPdfError()"
      >
      </ptl-playlist-report>
    </div>
  }
</div>
